import { useState } from "react";
import { IoIosArrowUp } from "react-icons/io";
import { IoIosArrowDown } from "react-icons/io";
import { Links } from "../services/Links";
import { Link } from "react-router-dom";

const NavLinks = () => {
  const [showSubMenu, setShowSubMenu] = useState(false);

  const navigation = Links();
  return (
    <>
      {navigation.map((item, index) => (
        <div key={index}>
          {" "}
          <div className="px-3 text-left md:cursor-pointer group">
            <Link
              to={item.to}
              className="py-4 flex justify-between item-center px-5 hover:bg-red-600 rounded "
              onClick={() =>
                showSubMenu !== item.name
                  ? setShowSubMenu(item.name)
                  : setShowSubMenu("")
              }
            >
              {item.name}
              {item.subMenu && (
                <>
                  <span className="text-xl md:hidden inline">
                    {showSubMenu === item.name ? (
                      <IoIosArrowUp />
                    ) : (
                      <IoIosArrowDown />
                    )}
                  </span>
                  <span className="text-xl md:mt-1 md:ml-2  md:block hidden group-hover:rotate-180 group-hover:-mt-2">
                    <IoIosArrowDown />
                  </span>
                </>
              )}
            </Link>

            {item.subMenu && (
              <div>
                <div className="absolute top-20 hidden group-hover:md:block hover:md:block">
                  <div className="py-3">
                    <div className="w-4 h-4 left-3 absolute mt-1 bg-red-600 rotate-45 "></div>
                  </div>
                  <div className="bg-red-600 p-3.5 rounded">
                    {item.subItems.map((subitem, subIndex) => (
                      <div key={subIndex}>
                        {" "}
                        <Link
                          to={subitem.to}
                          className="text-sm text-sky-500 p-2.5 hover:bg-sky-500 hover:text-blue-950 rounded"
                        >
                          {subitem.name}
                        </Link>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}
          </div>
          {/* mobile menus */}
          <div
            className={` ${showSubMenu === item.name ? "md:hidden" : "hidden"}`}
          >
            {item.subItems &&
              item.subItems.map((sub, subIndex) => (
                <Link
                  to={sub.to}
                  className="py-4 pl-7 font-semibold hover:bg-red-600 rounded"
                  key={subIndex}
                >
                  {sub.name}
                </Link>
              ))}
          </div>
        </div>
      ))}
    </>
  );
};

export default NavLinks;
